import { DEFAULT_DESCRIPTION, DEFAULT_TITLE, FOLK_CRAFT_COVER_URL, SITE_NAME } from './constants'

export { extractDescription, extractImage, canonicalPath, masterHighQualityCategoryPath } from './text'

export const STATIC_PAGE_SEO = {
  home: { title: DEFAULT_TITLE, description: DEFAULT_DESCRIPTION, section: '首页' },
  homeInfoAboutUs: { title: `关于我们 - ${SITE_NAME}`, description: '了解湖州市工艺美术学会的发展历程与使命。', section: '关于我们' },
  homeInfoContactUs: { title: `联系我们 - ${SITE_NAME}`, description: '湖州市工艺美术学会联系方式与地址。', section: '联系我们' },
  homeInfoCopyrightDisclaimer: { title: `版权说明 - ${SITE_NAME}`, description: '湖州市工艺美术学会网站版权与免责声明。', section: '版权说明' },
  homeInfoDesignSpecifications: { title: `设计规范 - ${SITE_NAME}`, description: '湖州市工艺美术学会视觉设计规范。', section: '设计规范' },
  masterGather: { title: `大师云集 - ${SITE_NAME}`, description: '中国、浙江省、湖州市工艺美术大师名录。', section: '大师云集' },
  masterHighQualityCategory: { title: `工美地图 - ${SITE_NAME}`, description: '湖州工艺美术大师按传统工艺分类展示。', section: '大师云集' },
  heritageGather: { title: `非遗传承 - ${SITE_NAME}`, description: '湖州非物质文化遗产传承人名录与介绍。', section: '非遗传承' },
  newsNotice: { title: `新闻动态 - ${SITE_NAME}`, description: '湖州市工艺美术学会最新新闻与动态。', section: '新闻动态' },
  folkCraftExhibition: { title: `湖州民间工艺精品展 - ${SITE_NAME}`, description: '“匠心造物 薪火相传”湖州民间工艺精品展线上展览，9月10日开幕，展期至9月25日。', section: '新闻动态', image: FOLK_CRAFT_COVER_URL },
  interviews: { title: `名家访谈 - ${SITE_NAME}`, description: '工艺美术名家访谈与深度报道。', section: '名家访谈' },
  research: { title: `学术研究 - ${SITE_NAME}`, description: '湖州工艺美术学术研究文章与成果。', section: '学术研究' },
}

export const PATH_SEO = {
  '/society/about': { title: `学会简介 - 学会概述 - ${SITE_NAME}`, description: '湖州市工艺美术学会简介与发展概况。' },
  '/society/bylaws': { title: `学会章程 - 学会概述 - ${SITE_NAME}`, description: '湖州市工艺美术学会章程全文。' },
  '/society/council': { title: `理事会成员 - 学会概述 - ${SITE_NAME}`, description: '湖州市工艺美术学会理事会成员名单。' },
  '/society/members': { title: `会员中心 - 学会概述 - ${SITE_NAME}`, description: '湖州市工艺美术学会会员名录与电子会员证下载。' },
  '/society/collection': { title: `工美馆藏 - 学会概述 - ${SITE_NAME}`, description: '湖州市工艺美术学会工美馆藏捐赠名录。' },
  '/society/notices': { title: `学会公告 - 学会概述 - ${SITE_NAME}`, description: '湖州市工艺美术学会最新公告与通知。' },
  '/highQuality/index': { title: `精品荟萃 - ${SITE_NAME}`, description: '湖州传统工艺美术精品作品荟萃展示。' },
  '/industryIntroduction/index': { title: `行业简介 - ${SITE_NAME}`, description: '湖州工艺美术各行业简介与特色介绍。' },
}

export function buildPageTitle(contentTitle, section) {
  if (!contentTitle) return DEFAULT_TITLE
  if (!section) return `${contentTitle} - ${SITE_NAME}`
  return `${contentTitle} - ${section} - ${SITE_NAME}`
}

export function getCategorySeo(section, categoryName) {
  return {
    title: buildPageTitle(categoryName, section),
    description: `${categoryName} - ${section} - ${SITE_NAME}`,
  }
}
